import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

function TitleUpdater({ title }) {
  const shopData = JSON.parse(localStorage.getItem("SHOP_DATA"));

  // console.log("shopData---->99", shopData)

  // Set the title when the 'title' prop changes
  useEffect(() => {
    document.title = title;
  }, [title, shopData?.id]);

  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
}

export default TitleUpdater;
